<template>
  <div>
    <base-tab :tabs="tabsData" @tab-click="tabSelected"></base-tab>
    <NewsArticleManagement v-show="isShow"></NewsArticleManagement>
    <NewsVideoManagement v-show="!isShow"></NewsVideoManagement>
  </div>
</template>

<script>
import NewsArticleManagement from './NewsArticleManagement'
import NewsVideoManagement from './NewsVideoManagement'
export default {
  name: 'NewsManagement',
  props: {
    memberId: String
  },
  data () {
    return {
      isShow: true,
      tabsData: [
        { id: 'wz', name: '文章', badge: 0 },
        { id: 'sp', name: '视频', badge: 0 }
      ]
    }
  },
  components: {
    NewsArticleManagement, NewsVideoManagement
  },
  methods: {
    tabSelected (tab) {
      this.isShow = this.tabsData[tab.index].id === 'wz'
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
